import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';

import { BaseProvider } from './base-provider';

@Injectable()
export class ConsumerServiceHandlerProvider extends BaseProvider {
	url: any;

	constructor(
		public http: Http,
		public globals: Globals,
        public storage: Storage,
        public httpHelper: HttpHelper
	){
		super();
	}

	getServiceByBusiness(params){	
	  	this.url = this.globals.dataUrl + 'consumerService/whiskey/' + this.globals.whiskeyId +
	  				 					  '/business/' + params.businessId + 
										  '/page/' + params.page +
										  '/size/' + params.size;

    	this.storage.get('loginData').then((loginData) => {
		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(
		    	res => {
		          if(typeof params.cb == "function") params.cb(res.Data);
		    	}
		    );   
    	})
  	}	

	getServiceByWhiskey(params){	
	  	this.url = this.globals.dataUrl + 'consumerService/whiskey/' + this.globals.whiskeyId +
										  '/page/' + params.page +
										  '/size/' + params.size;

    	this.storage.get('loginData').then((loginData) => {
		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(
		    	res => {
		          if(typeof params.cb == "function") params.cb(res.Data);
		    	}
		    );   
    	})
  	}	  	

	getBookingsByWhiskey(params){	
		return new Promise( (resolve, reject) => {
		  	this.url = this.globals.dataUrl + 'consumerService/bookings/whiskey/' + this.globals.whiskeyId +
											  '/page/' + params.page +
											  '/size/' + params.size;

			this.storage.get('loginData').then((loginData) => {
				this.http.get(
					this.url,
					this.httpHelper.configOptionsWithToken(loginData.access_token)
				)
				.map(res=>res.json())
				.subscribe(
					data => {
						this.list = data.Data;
						
						resolve(data);
					},
					err => {reject(err)}
				);
			});
		});       	
  	}	   	

	getServiceSchedule(params){	
	  	this.url = this.globals.dataUrl + 'consumerService/whiskey/' + this.globals.whiskeyId +
	  				 					  '/serviceId/' + params.serviceId;

    	this.storage.get('loginData').then((loginData) => {
		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(
		    	res => {
		          if(typeof params.cb == "function") params.cb(res.Data);
		    	}
		    );   
    	})
  	}	

	bookService(params){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + 'consumerService';

			this.storage.get('loginData').then((loginData) => {
				this.http.post(
					this.url,
					params,
					this.httpHelper.configOptionsWithToken(loginData.access_token)
				)
				.map(res=>res.json())
				.subscribe(
					data => {
						resolve(data);
					},
					err => {reject(err)}
				);
			});
		});       
	}	  	

	getBookingById(id){
		return new Promise( (resolve, reject) => {
		  	this.url = this.globals.dataUrl + 'consumerService/bookings/' + id;

			this.storage.get('loginData').then((loginData) => {
				this.http.get(
					this.url,
					this.httpHelper.configOptionsWithToken(loginData.access_token)
				)
				.map(res=>res.json())
				.subscribe(
					data => {
						this.item = data.Data;
						
						resolve(this.item);
					},
					err => {reject(err)}
				);
			});
		});  		
	}

	getBookingsByDate(params){
		this.url = this.globals.dataUrl + 'consumerService/bookings/service/' + params.serviceId +
										  '?date=' + params.date;

		this.storage.get('loginData').then((loginData) => {
			this.http
			.get(
			  this.url,
			  this.httpHelper.configOptionsWithToken(loginData.access_token)
			)
			.map(res => res.json())
			.subscribe(response => {
			    if(typeof params.cb == "function") params.cb(response.Data);
			});   			
		});          
	}	  	
}



// WEBPACK FOOTER //
// ./src/providers/consumer-service-handler.ts